import React, { useEffect, useState } from "react";
import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import {
  userDetailApi,
  userFollowerDetailApi,
  userPostDetailApi,
  userQuestionDetailApi,
  userToggleSubscription,
} from "services/user";
import { dateFormat } from "utils/dateFormat";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { AiOutlineDownload } from "react-icons/ai";
import { IoMdArrowRoundBack } from "react-icons/io";
import { paymentListApi } from "services/payment";
import NotFound from "common/NotFound";
import Referral from "pages/referral-management/Referral";
import useButtonLoader from "common/UseButtonLoader";

const UserDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [inputData, setInputData] = useState({});
  const [postData, setPostData] = useState([]);
  const [questionData, setQuestionData] = useState([]);
  const [followerData, setFollowerData] = useState([]);
  const [followData, setFollowData] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [activeTab, setActiveTab] = useState("posts");
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [toggleSubscripitonModal, setToggleSubscripitonModal] = useState(false);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // Function to check range
  const getMatchingTitle = (height, heightContent) => {
    const matchingItem = heightContent?.find((item) => {
      if (item.range.startsWith("<")) {
        // Handle ranges like "<5.2"
        return height < parseFloat(item.range.slice(1));
      } else if (item.range.startsWith(">")) {
        // Handle ranges like ">5.5"
        return height > parseFloat(item.range.slice(1));
      } else if (item.range.includes("-")) {
        // Handle ranges like "5.2-5.5"
        const [min, max] = item.range.split("-").map(parseFloat);
        return height >= min && height <= max;
      }
      return false;
    });

    return matchingItem?.title || "No matching range found";
  };
  const fetchingStudentDetail = async () => {
    await fetchData(userDetailApi, id, setInputData);
  };
  const fetchingPostDetail = async () => {
    await fetchData(userPostDetailApi, id, setPostData);
  };
  const fetchingQuestionDetail = async () => {
    await fetchData(userQuestionDetailApi, id, setQuestionData);
  };
  const fetchingTransectionDetail = async () => {
    const data = {
      userId: id,
    };

    await fetchData(paymentListApi, data, setTransactionData);
  };

  const fetchingFollowerDetail = async () => {
    const data = {
      type: "followers",
      userId: id,
    };
    await fetchData(userFollowerDetailApi, data, setFollowerData);
  };

  const fetchingFollowDetail = async () => {
    const data = {
      type: "following",
      userId: id,
    };
    await fetchData(userFollowerDetailApi, data, setFollowData);
  };

  console.log(transactionData, "data");
  // Generic fetch function with data setter
  const fetchData = async (apiCall, params = {}, setData) => {
    try {
      onShow();
      const res = await apiCall(params);
      if (res.data.status === 200) {
        setData(res.data.data);
        console.log(res.data.data, "fetched data");
      } else {
        toastMessage(res.data.message, "error", "dataFetch");
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  };

  const closeModal = () => {
    setToggleSubscripitonModal(false);
  };

  // toggle subscription status

  /**************Change Status Handler*********************/
  const toggleSubscriptionStatus = async () => {
    try {
      setButtonLoader(true);
      const sendData = {
        userId: id,
        action: inputData?.user?.planName === "Free" ? "make" : "remove",
      };
      const res = await userToggleSubscription(sendData);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeSubscripitonStatus");
        setButtonLoader(false);
        fetchingStudentDetail();
        closeModal();
      } else {
        toastMessage(res.data.message, "error", "changeSubscripitonStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    fetchingStudentDetail();
    fetchingPostDetail();
  }, []);
  // Handler for tab switching
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    switch (tab) {
      case "student":
        fetchingStudentDetail();
        break;
      case "posts":
        fetchingPostDetail();
        break;
      case "questions":
        fetchingQuestionDetail();
        break;
      case "followers":
        fetchingFollowerDetail();
        break;
      case "follow":
        fetchingFollowDetail();
        break;
      case "Transaction":
        break;
      default:
        break;
    }
  };
  return (
    <>
      {loader}
      <div className="editProfile user_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>
              <Link to={"/user-management"}>
                <IoMdArrowRoundBack />
              </Link>{" "}
              User details
            </h3>
            <div class="d-flex">
              <button
                variant="contained"
                class="button button mx-2"
                type="button"
                onClick={() => setToggleSubscripitonModal(true)}
              >
                {inputData?.user?.planName === "Free"
                  ? "Upgrade to Premium"
                  : "Downgrade to Free"}
              </button>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="image_wrap">
                {inputData.profilePreview ? (
                  <img src={inputData.profilePreview} alt="" />
                ) : (
                  <img
                    src={inputData?.user?.profile || userPlaceholderIcon}
                    alt=""
                  />
                )}
              </div>
              <div className="details_list">
                <ul>
                  <li>
                    <b>Name</b>
                    <span>{inputData?.user?.name}</span>
                  </li>
                  <li>
                    <b>Email</b>
                    <span>{inputData?.user?.email}</span>
                  </li>
                  <li>
                    <b>Mobile Number</b>
                    <span>
                      {inputData?.user?.countryCode + inputData?.user?.mobile}
                    </span>
                  </li>
                  <li>
                    <b>Date Of Birth</b>
                    <span>{dateFormat(inputData?.user?.dob)}</span>
                  </li>
                  <li>
                    <b>Subscription</b>
                    <span>{inputData?.user?.planName || "Free"}</span>
                  </li>
                  <li>
                    <b>Referral Code</b>
                    <span>{inputData?.user?.referralCode || ""}</span>
                  </li>
                  <li>
                    <b>Height</b>
                    <span>
                      {`${inputData?.user?.height?.fit}'${inputData?.user?.height?.inch} inch`}
                      {` (`}
                      {getMatchingTitle(
                        `${inputData?.user?.height?.fit}.${inputData?.user?.height?.inch}`,
                        inputData?.onboardingContent?.heightContent
                      )}
                      {`)`}
                    </span>
                  </li>
                  <li className="over_view">
                    <h5>Profile Overview</h5>
                    <p>
                      <b>{inputData?.posts}</b>
                      <span>Post</span>
                    </p>
                    <p>
                      <b>{inputData?.followerCount}</b>
                      <span>Follower</span>{" "}
                    </p>
                    <p>
                      <b>{inputData?.followingCount}</b>
                      <span>Following</span>{" "}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab_button_wrap">
              <ul>
                <li>
                  <button
                    type="button"
                    onClick={() => handleTabChange("posts")}
                    className={activeTab === "posts" ? "active" : ""}
                  >
                    Posts
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "questions" ? "active" : ""}
                    onClick={() => handleTabChange("questions")}
                  >
                    Questions
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "followers" ? "active" : ""}
                    onClick={() => {
                      handleTabChange("followers");
                    }}
                  >
                    Followers
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "follow" ? "active" : ""}
                    onClick={() => {
                      handleTabChange("follow");
                    }}
                  >
                    Follow
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Transaction" ? "active" : ""}
                    onClick={() => handleTabChange("Transaction")}
                  >
                    Transaction History
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "Referral" ? "active" : ""}
                    onClick={() => handleTabChange("Referral")}
                  >
                    Referral Activity
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab_content">
              {activeTab === "posts" && (
                <div className="post_details">
                  {/* Render post data */}
                  {postData?.posts && postData.posts.length > 0 ? (
                    postData.posts.map((post, postIndex) => (
                      <div key={post._id || postIndex} className="post_item">
                        {post.images && post.images.length > 0 ? (
                          <>
                            <div className="image_gallery">
                              <ul className="image_list">
                                {post.images.map((image, imageIndex) => (
                                  <li
                                    key={image._id || imageIndex}
                                    onClick={() => {
                                      setImagePreview(true);
                                      setImageUrl(
                                        image?.url || userPlaceholderIcon
                                      );
                                    }}
                                  >
                                    <img
                                      src={image.url || userPlaceholderIcon}
                                      alt={`Post ${postIndex + 1} - Image ${
                                        imageIndex + 1
                                      }`}
                                      className="post_image"
                                    />
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : (
                          <p></p>
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No posts available.</p>
                  )}
                </div>
              )}
              {activeTab === "questions" && (
                <div className="question_details">
                  {/* Render question data */}
                  <ul className="_title">
                    <li>
                      <b>Question</b>
                    </li>
                    <li>
                      <b>Answer</b>
                    </li>
                  </ul>
                  {questionData?.onboardingData &&
                  questionData.onboardingData.length > 0 ? (
                    questionData.onboardingData.map((item, index) => (
                      <div key={index} className="question_item">
                        <h5 className="question_text">{item.question}</h5>
                        <div className="answer_text">
                          {Array.isArray(item.answer) ? (
                            <ul className="answer_list">
                              {item.answer.map((answer, ansIndex) => (
                                <li key={ansIndex}>{answer},</li>
                              ))}
                            </ul>
                          ) : (
                            <p>{item.answer}</p>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No questions available.</p>
                  )}
                </div>
              )}
              {activeTab === "followers" && (
                <div className="follower_details">
                  {/* Render follower data */}
                  <h3>Followers:</h3>
                  {followerData?.users?.length > 0 ? (
                    <ul>
                      {followerData.users.map((follower) => (
                        <li key={follower._id}>
                          <img
                            src={
                              follower?.profile
                                ? follower?.profile
                                : userPlaceholderIcon
                            }
                            alt={follower.name}
                          />

                          <p>{follower.name}</p>
                          {/* If you have a profile image, you can display it here */}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No followers found.</p>
                  )}
                </div>
              )}
              {activeTab === "follow" && (
                <div className="follower_details">
                  {/* Render follower data */}
                  <h3>follow:</h3>
                  {followData?.users?.length > 0 ? (
                    <ul>
                      {followData.users.map((follow) => (
                        <li key={follow._id}>
                          <img
                            src={
                              follow?.profile
                                ? follow?.profile
                                : userPlaceholderIcon
                            }
                            alt={follow.name}
                          />

                          <p>{follow.name}</p>
                          {/* If you have a profile image, you can display it here */}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No follow found.</p>
                  )}
                </div>
              )}
              {activeTab === "Transaction" && (
                <>
                  <div className="table_wrap">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>S. No.</th>
                          <th>Transation ID</th>
                          <th>Transation Date</th>
                          <th>Transaction Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactionData.payments &&
                        transactionData?.payments?.length > 0 ? (
                          transactionData?.payments?.map((data, index) => {
                            return (
                              <tr key={++index}>
                                <td className="nowrap">{index + 1}</td>
                                {/* <td className="nowrap">{data?.userInfo?.name}</td>
                                    <td className="nowrap">{data?.amount}</td> */}
                                <td className="nowrap">{data?.paymentId}</td>
                                <td className="nowrap">
                                  {dateFormat(data?.createdAt)}
                                </td>
                                <td className="nowrap">{data?.type}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <NotFound
                            cols={12}
                            msg={"Payment data not found"}
                            onHide={onHide}
                          />
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              {activeTab === "Referral" && (
                <Referral UserDetail={inputData} showHeader={false} />
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal"}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>

      <PopupModal
        show={toggleSubscripitonModal}
        handleClose={closeModal}
        content="Are you sure you want to change subscripiton of this User?"
        title="Change Subscripition"
        onShow={toggleSubscriptionStatus}
        buttonLoader={buttonLoader}
      />
    </>
  );
};

export default UserDetail;
